import secureLocalStorage from "react-secure-storage";

import API from "./api";
const user = JSON.parse(secureLocalStorage.getItem("profile"));

const branch = user ? user.results.branch : "";

// sign in a new user
export const signIn = (formData) => API.post("/api/v1/users/login", formData);
// Sign up a new user
export const signup = (formData) => API.post("/api/v1/users/signup", formData);

// Security
// forgot password
export const forgotPassword = (postData) =>
  API.post("/api/v1/users/forgotPassword", postData);

// reset password
export const resetPassword = (token, postData) =>
  API.patch(`/api/v1/users/resetPassword/${token}`, postData);

// reset password
export const changePassword = (postData) =>
  API.patch(`/api/v1/users/updateMypassword`, postData);

export const getUsers = () => API.get("/api/v1/users");
// ! Update users information and delete users
export const updateUser = (id, postData) =>
  API.patch(`/api/v1/users/update-user/info/${id}`, postData);
export const deleteUser = (id) =>
  API.delete(`/api/v1/users/delete-selected-user/info/${id}`);

// ! ADVICE

export const getHeadOfficeAdviceFromBranches = () =>
  API.get("/api/v1/company-advice/advice-from-branches/organized");

export const createAdvice = (postData) =>
  API.post("/api/v1/company-advice", postData);

// !Advice Location
export const createLocation = (postData) =>
  API.post("/api/v1/advice-location", postData);
export const getAdviceLocation = () => API.get("/api/v1/advice-location");
export const deleteAdviceLocation = (id) =>
  API.delete(`/api/v1/advice-location/${id}`);

export const getBranchAdvice = () =>
  API.get(
    `/api/v1/company-advice?receiving_branch[eq]=${branch}&received[eq]=to&responded[eq]=false&approved[eq]=true`
  );
// unapproved advice

export const getUnapprovedAdvice = () =>
  API.get(`/api/v1/company-advice?branch[eq]=${branch}&approved[eq]=false`);

//! Get All branch Advice
export const getAllSpecificBranchAdvice = () =>
  API.get(`/api/v1/company-advice?branch[eq]=${branch}&approved[eq]=true`);
export const getAllSpecificReceivingAdvice = () =>
  API.get(
    `/api/v1/company-advice?receiving_branch[eq]=${branch}&approved[eq]=true`
  );
export const getAllAdvice = () =>
  API.get("/api/v1/company-advice?approved[eq]=true");

//! Update Advice
export const updateAdvice = (id, postData) =>
  API.patch(`/api/v1/company-advice/${id}`, postData);
export const deleteAdvice = (id) => API.delete(`/api/v1/company-advice/${id}`);
